const blue = [0.5058823529411764, 0.6784313725490196, 0.8627450980392157, 30];
const gray = [0.5, 0.5, 0.5, 20];

function generateAxis({ mobile, lastRing, normalizationFactor }) {
  // console.log("lastRings", lastRing);
  const positions = [];
  const vertexColors = [];
  const r = 6;

  const numAxis = 8;
  const numSteps = 10;
  for (let i = 0; i < numAxis; i++) {
    const axisR = mobile
      ? 10 * normalizationFactor * lastRing.radius[i] + 1.1
      : r;
    const a = (i / numAxis) * Math.PI * 2;

    const x = axisR * Math.cos(a);
    const y = axisR * Math.sin(a);
    positions.push([x * 0.001, y * 0.001, 0]);
    positions.push([x, y, 0]);
    positions.push([0, 0, 0]);
    vertexColors.push(blue, blue, blue);

    for (let j = 5; j < numSteps; j++) {
      const t = j / numSteps;

      const sr = (0.5 + 0.5 * t) * axisR;
      const x1 = sr * Math.cos(a);
      const y1 = sr * Math.sin(a);
      const len = Math.sqrt(x1 * x1 + y1 * y1);
      const nx1 = x1 / len;
      const ny1 = y1 / len;
      positions.push([x1 - ny1 * 0.05, y1 + nx1 * 0.05, 0]);
      positions.push([x1 - ny1 * 0.15, y1 + nx1 * 0.15, 0]);
      positions.push([0, 0, 0]);
      vertexColors.push(gray, gray, gray);
    }
  }

  if (!mobile)
    for (let i = 0; i < 360; i += 2) {
      const a = (i / 360) * Math.PI * 2;
      const r1 = r + 0.2;
      const r2 = r + 0.1;
      const x1 = r1 * Math.cos(a);
      const y1 = r1 * Math.sin(a);
      const x2 = r2 * Math.cos(a);
      const y2 = r2 * Math.sin(a);
      positions.push([x1, y1, 0]);
      positions.push([x2, y2, 0]);
      positions.push([0, 0, 0]);
      vertexColors.push(gray, gray, gray);
    }

  return {
    positions,
    vertexColors,
  };
}

export default generateAxis;
